<template>
  <div class="singIn verfication sso">
    <!-- <div class="logo">
			<div class="backIcon">
				<i class="el-icon-back cursor" @click="goBack"></i>
			</div>
			<div class="tvuLogo">
				<img src="./../assets/img/TVU networks Copy.png" alt="">
			</div>
		</div> -->
    <div class="formBody">
      <div class="singInLabel">
        <p class="tvuSingIn">{{$t('lang.singleSign')}}</p>
        <p class="tvuDescribe">{{$t('lang.companySign')}}</p>
      </div>
      <div class="singInForm">
        <div class="exchange emailArea">
          <div class="tip">{{$t('lang.entercode')}}</div>
          <el-input
            class="input"
            v-model="companyDomain"
            :placeholder="$t('lang.companyDomain')"
            @keyup.enter.native="nextOpaertaion"
            @blur="blurInput"></el-input>
          <div
            v-show="isShowSSO"
            class="warning">
            <i class="el-icon-warning-outline"></i>
            <span class="warningTip">{{$t('lang.errorOkta')}}
              <span
                class='ssoConfig cursor'
                @click="goToConfig">{{$t('lang.ssoConfig')}}</span>
            </span>
          </div>
        </div>
        <div :class="[isWaiting?'waitingStyle':'','confirmArea'] ">
          <span
            class="cursor createAccount"
            @click="goHome">{{$t('lang.withoutOkta')}}</span>
          <!-- :disabled='isDisabeBtn' -->
          <el-button
            class="confirmBtn cursor"
            :disabled='isDisabeBtn'
            v-repeat-click="{event:nextOpaertaion}"
            :loading="isLoading">{{$t('lang.singIn')}}
            <i
              v-show='isWaiting'
              class='el-icon-refresh-right'></i>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  name: 'CreateAccount',
  data () {
    return {
      companyDomain: '',
      isDisabeBtn: true,
      isShowTip: false,
      isWaiting: false,
      isLoading: false,
      isShowSSO: false
    }
  },
  mounted () {

  },
  watch: {
    companyDomain: function (newVal) {
      if ($('.emailArea').hasClass('errorInput')) {
        $('.emailArea').removeClass('errorInput')
      }
      if (!newVal) {
        this.isDisabeBtn = true
      } else {
        this.isDisabeBtn = false
        this.isShowTip = false
      }
    }

  },
  computed: {

  },
  methods: {
    goHome () {
      // ga('send', 'event', 'newUserService-verify-goBack', 'click')
      gtag('event', 'newUserService-verify-goBack')
      this.$router.push('/')
    },
    goToConfig () {
      this.$store.commit('changeShowConfig', true)
      this.$router.push('/ssoConfig')
    },
    blurInput () {
      if (!this.companyDomain) {
        this.isShowSSO = false
      }
    },
    nextOpaertaion () {
      // this.$router.push('/register')
      if (!this.companyDomain) {
        this.isDisabeBtn = true
        return
      }
      this.isDisabeBtn = false

      this.axios.post(`/userGroup/user-group/login/saml/redirect?companyDomain=${this.companyDomain}`, {}).then((res) => {
        // if(res.data.errorCode == '0x0'){
        // 跳转code页面
        if (res.data.errorCode == '80944602') {
          this.isShowSSO = true
        } else if (res.data.errorCode == '0x0') {
          location.href = res.data.result
        } else {
          this.$message({
            message: res.data.errorInfo,
            type: 'error',
            duration: 3000
          })
        }
      }).catch()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('changeShowConfig', false)
    })
  },
  filters: {

  }
}
</script>
